module.exports = __webpack_public_path__ + "img/icon-vr.21e2e56.png";